import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaPlus } from 'react-icons/fa';
import PageContainer from '../../../../components/PageContainer';
import ListLayout from '../../../../components/ListLayout';
import Loading from '../../../../components/Loading';
import useAlertNotification from '../../../../context/AlertNotificationContext';
import ErrorRequestService from '../../../../services/errorRequest';
import CargaHorariaApiService from '../../../../services/api/CargaHorariaApiService';
import { storeCargaHoraria } from '../../../../store/actions/dadosActions';
import { columns } from './CargaHorariaListInfo';
import RegimeApiService from '../../../../services/api/RegimeApiService';

const INITIAL_PAGEPARAMS = {
    orderBy: 'cod',
    orderDir: 'asc'
};
const ORDER_DIR_NUM = { asc: 1, desc: -1 };

function CargaHorariaList(props) {
    // CONTEXT
    const match = useRouteMatch();
    const history = useHistory();
    const alert = useAlertNotification();

    // STATE
    const [rowsData, setRowsData] = useState(null);
    const [filteredData, setFilteredData] = useState(null);
    const [orderBy, setOrderBy] = useState(INITIAL_PAGEPARAMS.orderBy);
    const [orderDir, setOrderDir] = useState(INITIAL_PAGEPARAMS.orderDir);
    const [isLoading, setIsLoading] = useState(true);

    // FUNCTIONS
    /** Define o clique sobre um registro da lista */
    const rowClick = (item) => {
        history.push(`${match.url}/${item.cod}`, item);
    }

    /** Adiciona click e atributos ao header */
    const getListHeader = () => {
        const headers = [];
        const defineOrder = (item) => {
            if (orderBy === item) {
                const newDir = (orderDir === 'asc') ? 'desc' : 'asc';
                setOrderDir(newDir);
                return;
            }
            setOrderBy(item);
        }
        columns.forEach(item => {
            const waySign = (ORDER_DIR_NUM[orderDir] > 0) ? '▴' : '▾';
            const orderInd = (orderBy === item.name) 
                ? { ordered: `${waySign}` }
                : {};
            const head = {
                ...item,
                ...orderInd,
                onClick: () => defineOrder(item.name),
            }
            headers.push(head);
        })
        return headers;
    }

    /** Adequa os dados ao formato para lista */
    const defineDataList = () => {
        const normalizeValue = (val) => {
            if (typeof val === "string" && val.match(/^\d+h$/)) {
                return parseInt(val.replace("h", ""), 10);
            }
            return val;
        };

        const sortRows = (a, b) => {
            const valA = normalizeValue(a[orderBy]);
            const valB = normalizeValue(b[orderBy]);

            if (valA < valB) return (-1 * ORDER_DIR_NUM[orderDir]);
            if (valA > valB) return (1 * ORDER_DIR_NUM[orderDir]);
            return 0;
        };

        const dataList = [];
        const rows = filteredData || [];

        rows.sort(sortRows).forEach(item => {
            const row = {
                onClick: () => rowClick(item),
                data: columns.map(col => ({
                    value: item[col.name],
                    className: col.className
                }))
            };
            dataList.push(row);
        });

        return dataList;
    };

    /* Filtra a lista de dados */
    const filterList = (params) => {
        const { column, filter, isOptionFilter } = params;
        if (!column || !filter) {
            setFilteredData(rowsData); // filtro local
            return
        }
        
        // APLICA FILTRO LOCAL
        const filtered = rowsData.filter(item => {
            const lwData = String(item[column]).toLowerCase();
            const lwFilter = String(filter).toLowerCase();

            if (isOptionFilter) return parseInt(item[column]) === parseInt(lwFilter) && item;

            return lwData.includes(lwFilter);
        });

        setFilteredData(filtered);
    }

    /** Traz as cargas horárias cadastradas no database  */
    const getDataList = useCallback(async () => {
        try {
            setIsLoading(true);

            const resp = await CargaHorariaApiService.getAll();
            const regime = await RegimeApiService.getAll();

            const { data } = resp;
            
            const newData = data.map(item => {
                const regimeItem = regime.data.data.find(
                    reg => reg.cod === item.id_regime
                    );
                return {
                    ...item,
                    hora_dia: `${item.hora_dia}h`,
                    hora_total: `${item.hora_total}h`,
                    id_regime: regimeItem ? `${regimeItem.sigla} - ${regimeItem.nome}` : item.id_regime,
                }
            })

            setRowsData(newData);
            setFilteredData(newData);
        }
        catch (err) {
            const errorService = new ErrorRequestService(err);
            const errorMsg = errorService.getErrors(); 
            console.log(errorMsg);
            alert.error(errorMsg);
        }
        finally {
            setIsLoading(false);
        }
    }, [orderBy, orderDir]);

    // EFFECTS
    useEffect(getDataList, []);

    const pageActions = [
        { 
            label: 'Novo',
            icon: <FaPlus />,
            color: 'primary',
            type: 'button',
            href: `${match.path}/new`,
        }
    ]

    const title = 'Lista de Cargas Horárias';

    return (
        <PageContainer 
            title={title}
            actions={pageActions}
        >
            { isLoading 
                ? <Loading message="Carregando..." />
                : <ListLayout
                    columns={getListHeader()}
                    rows={defineDataList()}
                    onSubmitFilter={filterList}  
                />
            }

        </PageContainer>
    )
}

export default CargaHorariaList;
